import React from 'react';
import Header from "./Header";
import Footer from "./Footer";
import { useEffect } from 'react';

const HomePage = ({ setCurrentPage }) => {
   useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // 可选：平滑滚动
  }, []);
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-emerald-800 relative overflow-hidden">
      <div className="absolute inset-0 bg-black opacity-20"></div>
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"></div>
        <div className="absolute top-40 right-10 w-72 h-72 bg-emerald-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse animation-delay-2000"></div>
        <div className="absolute bottom-20 left-1/3 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse animation-delay-4000"></div>
      </div>
      
      {/* Header */}
     <Header currentPage="home" setCurrentPage={setCurrentPage} />

      <main className="pt-36 pb-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <div className="inline-block bg-white/20 backdrop-blur-sm text-white text-lg font-semibold px-8 py-4 rounded-full mb-12 border border-white/30">
            专注新能源投资与运营 · 注册资本3.986亿元
          </div>
          <h1 className="text-6xl lg:text-7xl font-extrabold text-white mb-8 leading-tight tracking-tight">
            引领云南绿色
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-emerald-300">能源转型</span>
          </h1>
          <p className="text-2xl text-blue-100 mb-16 leading-relaxed max-w-4xl mx-auto">
            西航投（云南）新能源有限公司，依托西航集团雄厚资本实力，致力于储能电站、风能、太阳能等新能源项目的投资、建设与运营，推动云南能源结构优化，助力实现碳中和目标。
          </p>
          <div className="flex flex-wrap justify-center gap-8 mb-20">
            <button
              onClick={() => setCurrentPage("tenders")}
              className="bg-gradient-to-r from-blue-600 to-emerald-600 text-white px-12 py-6 rounded-2xl font-bold text-xl hover:from-blue-700 hover:to-emerald-700 transform hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-blue-500/25"
            >
              招标信息公示
            </button>
            <button
              onClick={() => setCurrentPage("suppliers")}
              className="border-2 border-white text-white px-12 py-6 rounded-2xl font-bold text-xl hover:bg-white hover:text-gray-900 transition-all duration-300 shadow-2xl"
            >
              查看入围供应商
            </button>
            <button
              onClick={() => setCurrentPage("business")}
              className="border-2 border-blue-300 text-blue-200 px-12 py-6 rounded-2xl font-bold text-xl hover:bg-blue-300 hover:text-white transition-all duration-300 shadow-2xl"
            >
              了解核心业务
            </button>
          </div>
          
          {/* Key Stats with enhanced design */}
          <div className="grid md:grid-cols-3 gap-12 text-center mb-20">
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-10 shadow-2xl border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="text-5xl font-bold text-blue-300 mb-4">3.986</div>
              <div className="text-blue-100 font-medium text-xl">亿注册资本</div>
              <div className="w-16 h-1 bg-gradient-to-r from-blue-400 to-blue-600 mx-auto mt-4"></div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-10 shadow-2xl border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="text-5xl font-bold text-emerald-300 mb-4">20+</div>
              <div className="text-emerald-100 font-medium text-xl">专业团队</div>
              <div className="w-16 h-1 bg-gradient-to-r from-emerald-400 to-emerald-600 mx-auto mt-4"></div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-10 shadow-2xl border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="text-5xl font-bold text-purple-300 mb-4">2025</div>
              <div className="text-purple-100 font-medium text-xl">成立年份</div>
              <div className="w-16 h-1 bg-gradient-to-r from-purple-400 to-purple-600 mx-auto mt-4"></div>
            </div>
          </div>

          {/* Strategic Advantages */}
          <div className="bg-white/10 backdrop-blur-sm rounded-4xl p-12 border border-white/20">
            <h3 className="text-4xl font-bold text-white mb-10 text-center">战略优势</h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-500 rounded-3xl flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h4 className="text-2xl font-semibold text-white mb-4">轻资产模式</h4>
                <p className="text-blue-200">专注核心竞争力，灵活资本运作，优化供应链管理，提高运营效率</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-500 rounded-3xl flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h4 className="text-2xl font-semibold text-white mb-4">区域布局</h4>
                <p className="text-blue-200">聚焦云南本土市场，拓展西南地区合作，探索一带一路沿线市场</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-purple-500 rounded-3xl flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </div>
                <h4 className="text-2xl font-semibold text-white mb-4">碳中和目标</h4>
                <p className="text-blue-200">开发可再生能源项目，推动绿色交通与物流，助力实现碳中和</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer currentPage="home" setCurrentPage={setCurrentPage} /> 
      
    </div>
  );
};

export default HomePage;